import type { Config } from 'tailwindcss';
import sharedConfig from '@vp/common/tailwind/config';

export default {
  content: [
    './index.html',
    './src/**/*.{vue,js,ts,jsx,tsx}',
    './lib/forms/src/**/*.{vue,js,ts,jsx,tsx}',
    './packages/vue-components/lib/**/*.{vue,js,ts,jsx,tsx}',
  ],
  theme: {
    extend: {
      spacing: {
        648: '648px',
        612: '612px',
      },
      colors: {
        ...sharedConfig.theme.extend.colors,
        // Names need to be prefixed in order not to clash with existing clases
        // present in venuepilot app.
        // TODO: Remove this and use 'vp-base' instead.
        'vp-dark': '#191F40',
        // 'vp-primary': '#F93E86',
        'vp-primary': {
          900: '#E9498C',
          600: '#FD84B7',
          400: '#FEDCEA',
          DEFAULT: '#E9498C',
        },
        'vp-primary-2': {
          900: '#154285',
          DEFAULT: '#154285',
        },
        'vp-base': {
          900: '#191F40',
          800: '#282E4C',
          700: '#4B4F68',
          600: '#6B6E83',
          500: '#8E8F9F',
          400: '#ADADB8',
          300: '#DAD9DD',
          200: '#EBEAEC',
          150: '#F7F4F4',
          100: '#FEFBFA',
          DEFAULT: '#191F40',
        },
        'vp-error': '#EE3D3D',
        'vp-secondary-1': {
          900: '#2C6CA6',
          400: '#8DC4F6',
          200: '#C6E3FE',
          DEFAULT: '#2C6CA6',
        },
        'vp-secondary-2': {
          900: '#43A1C6',
          400: '#ACE5FC',
          DEFAULT: '#43A1C6',
        },
        'vp-secondary-3': {
          900: '#5AB4BB',
          300: '#C6F3F6',
          200: '#DCFDFF',
          DEFAULT: '#5AB4BB',
        },
        'vp-secondary-4': '#FEF5BE',
        'vp-secondary-5': '#FEE3BE',
        'vp-secondary-6': '#FDCABE',
        'vp-gray': {
          lighter: '#FEFBFA',
          light: '#f2f6ff',
          'light-2': '#EBEAEC',
          DEFAULT: '#DAD9DD',
          normal: '#6B6E83',
          dark: '#ADADB8',
        },
        'vp-purple': {
          lighter: '#F8DDE9',
          light: '#e8e3ff',
          medium: '#8E8F9F',
          dark: '#191F40',
        },
        'vp-blue': {
          300: '#EDF4FC',
          lighter: '#DCFDFF',
          light2: '#C6E3FE',
          light: '#8DC4F6',
        },
        'vp-green': {
          light: '#5AB3BB',
        },
        'vp-pink': {
          lighter: '#FEDCEA',
          DEFAULT: '#E9498C',
        },
        'vp-yellow': {
          light: '#FEE3BE',
        },
        'vp-orange': {
          light: '#FDCABE',
        },
      },
      scale: {
        98: '.98',
        99: '.99',
      },
      width: {
        30: '7.5rem',
        86: '21.5rem',
      },
      minWidth: {
        69: '69px',
        78: '78px',
        30: '7.5rem',
      },
      maxWidth: {
        60: '60rem',
        69: '69px',
        78: '78px',
        120: '120px',
        140: '140px',
        121: '121px',
      },
      height: {
        29: '29px',
        44: '44px',
        37: '37px',
        45: '45px',
        56: '56px',
      },
      minHeight: {
        8: '2rem',
        12: '3rem',
        16: '4rem',
        29: '29px',
        44: '44px',
      },
      fontSize: {
        xxs: '9px',
        regular: '17px',
        '2xs': 'var(--vp-font-size-2xs, 0.8rem)',
        '3xs': '0.56rem',
      },
    },
  },
  plugins: [],
  corePlugins: {
    backgroundOpacity: false,
  },
} satisfies Config;
